import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    '&&': {
      minWidth: 300,
      minHeight: 400,

      padding: SPACES.xxl,
    },
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: SPACES.xxxxl,
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.xxl,
      fontWeight: FONTS.WEIGHTS.bold,
      lineHeight: 1.4,
      textAlign: 'center',

      color: theme.palette.custom.darkBlue2,
    },
  },
  upperWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxl,
    },
  },
  itemWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxxs,
    },
  },
  itemTitle: {
    '&&': {
      color: theme.palette.custom.grey2,
      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.semi_bold,
    },
  },
  lowerWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxxxl,
    },
  },
  paymentWrapper: {
    '&&': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  paymentText: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
    },
  },
  subscriptionText: {
    '&&': {
      textTransform: 'capitalize',
      color: theme.palette.custom.darkBlue2,
    },
  },
  closeButton: {
    '&&': {
      borderRadius: '50%',
      position: 'absolute',

      [theme.breakpoints.down('tablet')]: {
        top: 0,
        right: 0,
      },
      [theme.breakpoints.up('tablet')]: {
        top: 4,
        right: 4,
      },
    },
  },
}))

export { useStyles }
